import axios from 'axios';
import { getCookieValue } from '../utils';

const baseURL = process.env.REACT_APP_API_BASE_URL;

axios.defaults.baseURL = baseURL;

const http = axios.create();

http.interceptors.request.use(
  async (config) => {
    const token = getCookieValue('_session_id');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default http;
